import { render, staticRenderFns } from "./tipo-reporte.vue?vue&type=template&id=d7968f52"
import script from "./tipo-reporte.vue?vue&type=script&lang=js"
export * from "./tipo-reporte.vue?vue&type=script&lang=js"
import style0 from "./tipo-reporte.vue?vue&type=style&index=0&id=d7968f52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports